module.exports = __webpack_public_path__ + "static/media/1.eed46b05.jpg";